import { environment } from 'src/environments/environment';

import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./dashboard/ui/pages/index-page/index.page').then(
        (m) => m.IndexPage,
      ),
  },
  {
    path: 'details/:mapID/',
    loadComponent: () =>
      import('./dashboard/ui/pages/details/details-page/details.page').then(
        (m) => m.DetailsPage,
      ),
  },
  {
    path: 'details/:mapID',
    loadComponent: () =>
      import('./dashboard/ui/pages/details/details-page/details.page').then(
        (m) => m.DetailsPage,
      ),
  },
  {
    path: 'details/:mapID/gps/',
    loadComponent: () =>
      import('./dashboard/ui/pages/details/details-page/gps-details.page').then(
        (m) => m.GpsDetailsPage,
      ),
  },
  {
    path: 'details/:mapID/gps',
    loadComponent: () =>
      import('./dashboard/ui/pages/details/details-page/gps-details.page').then(
        (m) => m.GpsDetailsPage,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./dashboard/ui/pages/not-found-page/not-found.page').then(
        (m) => m.NotFoundPage,
      ),
  },
];

// NOTE: dashboardリファクタ作業で利用します.
// 用途: コンポーネント分割する際に親のcssに依存しない書き方をするために, 作業場としてこのページを利用します. リファクタ作業が完了したら消します.
if (environment.envName === 'dev') {
  routes.unshift({
    path: 'dev/components-list',
    loadComponent: () =>
      import(
        './dashboard/ui/pages-dev/dev/components-list/components-list.page'
      ).then((m) => m.ComponentsListPage),
  });
}
